import type { CountryCode } from 'libphonenumber-js/min';

export interface TelCountry {
    iso: CountryCode;
    name: string;
    flag: string;
}

/** A curated list scoped to the platform's real trade geography (GCC/MENA plus the
 *  major sourcing markets distributors deal with) rather than all ~240 ISO
 *  countries — keeps the picker scannable. UAE first as the default/most common. */
export const TEL_COUNTRIES: TelCountry[] = [
    { iso: 'AE', name: 'United Arab Emirates', flag: '🇦🇪' },
    { iso: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
    { iso: 'QA', name: 'Qatar', flag: '🇶🇦' },
    { iso: 'KW', name: 'Kuwait', flag: '🇰🇼' },
    { iso: 'BH', name: 'Bahrain', flag: '🇧🇭' },
    { iso: 'OM', name: 'Oman', flag: '🇴🇲' },
    { iso: 'EG', name: 'Egypt', flag: '🇪🇬' },
    { iso: 'JO', name: 'Jordan', flag: '🇯🇴' },
    { iso: 'LB', name: 'Lebanon', flag: '🇱🇧' },
    { iso: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
    { iso: 'US', name: 'United States', flag: '🇺🇸' },
    { iso: 'IN', name: 'India', flag: '🇮🇳' },
    { iso: 'PK', name: 'Pakistan', flag: '🇵🇰' },
    { iso: 'CN', name: 'China', flag: '🇨🇳' },
    { iso: 'DE', name: 'Germany', flag: '🇩🇪' },
    { iso: 'FR', name: 'France', flag: '🇫🇷' },
];
